import React from 'react';
import WorkoutPlanGenerator from '../components/WorkoutPlanGenerator';

const WorkoutPlans = ({ YOUTUBE_CHANNEL }) => {
  return (
    <div className="min-h-screen bg-black py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-yellow-400 uppercase tracking-wide mb-3 sm:mb-4">
            Workout Plans
          </h1>
          <p className="text-gray-400 text-base sm:text-lg">
            Generate your personalized workout plan based on your goals
          </p>
        </div>

        <WorkoutPlanGenerator YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} />
      </div>
    </div>
  );
};

export default WorkoutPlans;
